import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 5
	render() {
		const style = {
			st30: {
				fill: '#5994C9',
			},
			st62: {
				fill: '#F9914B',
			},
			st81: {
				opacity: 0.4,
				fill: '#FFFFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="65.3255768" cy="122.6258469" />
				<path style={style.st30} d="M117.6008301,95.3701172l-7.2515869-0.9775391
					c-2.255249-0.302002-4.4946899-0.5734863-6.7631226-0.8300781c-0.6553955-0.0742188-1.2986755-0.1428223-1.9551697-0.2132568
					c-1.7168579-0.18396-3.4300079-0.3546143-5.15242-0.5125732c-0.6397705-0.0585938-1.2748795-0.1203613-1.9151993-0.1755371
					c-2.2410889-0.1925049-4.4833603-0.3679199-6.7306061-0.5162354c-0.4397049-0.0290527-0.8777618-0.0494385-1.3174591-0.0767822
					c-1.8406982-0.1142578-3.6819763-0.2141113-5.5247498-0.2984619c-0.3438721-0.0157471-0.68853-0.0411377-1.0322189-0.0557861
					c-0.0869141-0.0036621-0.1724472-0.1390381-0.2593002-0.1416016c-4.7470703-0.1994629-9.496666-0.4550781-14.2365952-0.4550781
					h-0.0117188c-4.7381592,0-9.4862671,0.2556152-14.2316895,0.4549561
					c-0.088501,0.0025635-0.1758423,0.0661621-0.2644043,0.0699463c-0.3440552,0.0146484-0.68927,0.0759277-1.0335083,0.0917969
					c-1.8400879,0.0842285-3.6790771,0.2019043-5.5171509,0.31604c-0.442627,0.0274658-0.8844604,0.0568237-1.3270874,0.0861206
					c-2.2455444,0.1481934-4.4876709,0.3279724-6.7271118,0.5203552c-0.6433105,0.0554199-1.284668,0.1196747-1.9274292,0.1787567
					c-1.7191162,0.1574707-3.4351807,0.3290024-5.1487427,0.5125961c-0.6585083,0.0705566-1.3164062,0.1399612-1.9738159,0.2144318
					c-2.2677612,0.2564621-4.5315552,0.5281067-6.7860718,0.8301086l-7.1582031,0.977684
					C5.5336914,96.4178314,0,102.1342773,0,108.9628906v28.434082c0,6.8291016,5.5336914,12.5454102,13.3554688,13.5922852
					l7.2299805,0.9780273c5.1801758,0.6938477,10.4157715,1.2744141,15.6330566,1.7250977
					c0.644043,0.0556641,1.2662354,0.0834961,1.9019775,0.0834961c7.5551758,0,14.4060669-3.8764648,17.8181763-10.2163086
					l9.5223083-18.8486328l9.4533844,18.7114258l0.0706558,0.1376953
					c3.4125977,6.3398438,10.2714157,10.2158203,17.8265915,10.2158203c0.6352539,0,1.2755966-0.027832,1.9191513-0.0834961
					c5.2167969-0.4506836,10.4881363-1.03125,15.6688004-1.7250977l7.2008591-0.9780273
					C125.4226761,149.9423828,131,144.2260742,131,137.3969727v-28.434082
					C131,102.1342773,125.4230957,96.4179688,117.6008301,95.3701172z M59.3413086,110.2075195L45.331543,137.9291992
					c-1.421875,2.578125-4.668457,4.1025391-8.1152344,3.8081055c-5.03125-0.4350586-10.1152344-0.9946289-15.1098633-1.6635742
					l-7.1586914-0.9780273C12.8203125,138.8105469,12,137.6962891,12,137.3969727v-28.434082
					c0-0.2993164,0.8203125-1.4140625,2.9482422-1.6992188l7.2299805-0.9775391
					c2.1711426-0.2907715,4.3193359-0.5527344,6.5076904-0.8001709c0.6337891-0.0716553,1.2508545-0.1383057,1.8855591-0.2061768
					c1.6554565-0.1774902,3.3050537-0.3419189,4.9661865-0.4942627c0.6153564-0.0563965,1.2256165-0.1160889,1.8415833-0.1689453
					c2.1672974-0.1864014,4.3347931-0.3555908,6.5048981-0.4989014c0.3999023-0.0263672,0.7994156-0.0449219,1.199501-0.0698242
					c1.8065796-0.1125488,3.6117439-0.2102051,5.41576-0.2924805c0.4732056-0.0217285,0.9462547-0.0394287,1.4195786-0.059082
					c2.2230873,0.0107422,4.3040009,0.798584,5.7647552,2.199707c0.8076172,0.7744141,1.7694588,2.0766602,1.7679939,3.8828125
					C59.4517288,109.918457,59.4145508,110.0625,59.3413086,110.2075195z M119,137.3969727
					c0,0.2993164-0.8635254,1.4135742-2.9919434,1.6987305l-7.2515869,0.9780273
					c-4.9956055,0.6689453-10.0540161,1.2285156-15.0847778,1.6635742c-3.4389648,0.2958984-6.6808167-1.230957-8.1031799-3.8081055
					l-14.0039825-27.7246094c-0.0722656-0.1430664-0.1062393-0.2866211-0.1062393-0.425293
					c-0.0014648-1.8061523,0.9625015-3.1088867,1.770607-3.8837891c1.5016479-1.4396973,3.6735764-2.2253418,5.954155-2.1912842
					c0.409668,0.0172119,0.8197937,0.0323486,1.2294617,0.0511475c1.807251,0.0822754,3.6165237,0.1801758,5.4263992,0.2929688
					c0.3964233,0.0247803,0.7934952,0.0432129,1.1897354,0.0693359c2.1721191,0.1433105,4.3439255,0.3125,6.5133591,0.4992676
					c0.6119995,0.0524902,1.2228622,0.1118164,1.8343124,0.1677246c1.6659546,0.152832,3.3294754,0.317749,4.9897537,0.4957275
					c0.6311646,0.067627,1.2627029,0.1337891,1.892952,0.2050781c2.1896973,0.2476807,4.3750687,0.5096436,6.5476151,0.8006592
					l7.201416,0.9775391C118.1364746,107.5488281,119,108.6635742,119,108.9628906V137.3969727z" />
				<path style={style.st30} d="M78.8097305,177.6767578H52.1160088c-5.9370537,0-10.7499886-4.8129272-10.7499886-10.7499847v-3.6191711
					c0-5.9370575,4.8129349-10.7499847,10.7499886-10.7499847h26.6937218c5.9370575,0,10.7499924,4.8129272,10.7499924,10.7499847
					v3.6191711C89.5597229,172.8638306,84.746788,177.6767578,78.8097305,177.6767578z" />
				<path style={style.st62} d="M103.2910156,216.8828125c-26.3725586,0-47.828125-21.4555664-47.828125-47.828125
					c0-5.5229492,4.4770508-10,10-10s10,4.4770508,10,10c0,15.3442383,12.4833984,27.828125,27.828125,27.828125
					s27.828125-12.4838867,27.828125-27.828125v-164.9375h20v164.9375
					C151.1191406,195.4272461,129.6635742,216.8828125,103.2910156,216.8828125z" />
				<path style={style.st81} d="M68.5239105,117.875206l11.5428848,22.8408737
					c2.537674,4.7156525,8.1107025,7.5037537,13.9465256,6.9989471c5.144989-0.4450684,10.277092-1.009903,15.3893814-1.6945343
					l7.301796-0.9778442C121.4979782,144.4007263,125,141.1730804,125,137.3970795v-28.434433
					c0-3.776001-3.5020218-7.0036469-8.2955017-7.6455841l-7.301796-0.9778366
					c-14.6096039-1.9564896-29.381073-2.9347382-44.1525345-2.9347458
					c-14.7714615,0.0000076-29.542923,0.9782562-44.1525345,2.9347458l-7.3017969,0.9778366
					c-4.7934818,0.6419373-8.2954998,3.8695831-8.2954998,7.6455841v28.434433c0,3.776001,3.5020185,7.0036469,8.2954998,7.6455688
					l7.3017969,0.9778442c5.1122875,0.6846313,10.2443924,1.2494659,15.3893833,1.6945343
					c5.8358231,0.5048065,11.4088516-2.2832947,13.9465218-6.9989471l11.5428848-22.8408737h0.0000038
					C63.5212517,115.5157852,66.9790878,115.5157852,68.5239105,117.875206L68.5239105,117.875206z" />
				<path style={style.st30} d="M151,10.1171875h-20c-2.7612305,0-5-2.2387695-5-5s2.2387695-5,5-5h20c2.7612305,0,5,2.2387695,5,5
					S153.7612305,10.1171875,151,10.1171875z" />
				<path style={style.st30} d="M151,128.1171875h-20c-2.7612305,0-5-2.2387695-5-5s2.2387695-5,5-5h20c2.7612305,0,5,2.2387695,5,5
					S153.7612305,128.1171875,151,128.1171875z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 5
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="34.6225548" cy="64.9295883" />
				<path fill="#5994C9" d="M62.3284416,50.4840546l-3.8433418-0.5180969
					c-1.195282-0.1600609-2.3821869-0.3039474-3.5844574-0.4399414c-0.3473587-0.0393372-0.6882973-0.075695-1.0362396-0.1130257
					c-0.909935-0.0974998-1.8179016-0.1879463-2.7307816-0.2716637c-0.339077-0.0310555-0.6756859-0.0637932-1.0150566-0.0930367
					c-1.1877747-0.1020279-2.3761787-0.1949959-3.5672226-0.2736053c-0.2330399-0.0153961-0.46521-0.0261993-0.6982498-0.0406914
					c-0.9755707-0.0605583-1.9514503-0.1134796-2.9281197-0.1581879c-0.182251-0.0083466-0.3649178-0.021801-0.5470734-0.0295639
					c-0.0460663-0.0019417-0.0913963-0.0736923-0.1374283-0.0750504c-2.5159492-0.1057167-5.0332336-0.2411919-7.5453987-0.2411919
					h-0.0062103c-2.5112228,0-5.0277214,0.1354752-7.5427952,0.241127c-0.0469055,0.001358-0.0931969,0.0350647-0.1401348,0.0370712
					c-0.1823483,0.0077629-0.3653126,0.0402412-0.5477581,0.0486526c-0.9752464,0.0446396-1.9499111,0.1070099-2.9240913,0.1674995
					c-0.2345905,0.0145569-0.4687634,0.030117-0.7033558,0.0456467c-1.1901379,0.0785408-2.3784657,0.1738243-3.5653687,0.2757874
					c-0.3409557,0.0293732-0.6808739,0.063427-1.0215378,0.0947418c-0.9111309,0.0834579-1.8206463,0.1743698-2.7288332,0.2716751
					c-0.3490095,0.0373955-0.6976957,0.0741806-1.0461226,0.1136475c-1.2019138,0.1359291-2.4017248,0.2798996-3.5966187,0.4399605
					l-3.7938476,0.5181694C2.9328566,51.039341,0,54.0690575,0,57.688221v15.0700645
					c0,3.6194229,2.9328566,6.6490707,7.0783982,7.2039108l3.8318896,0.5183563
					c2.7454929,0.3677368,5.520359,0.6754379,8.2855206,0.914299c0.3413429,0.0295029,0.6711044,0.0442581,1.0080471,0.0442581
					c4.0042439,0,7.6352158-2.0545273,9.443634-5.41465l5.0468235-9.989769l5.0102921,9.9170532l0.0374489,0.0729752
					c1.8086777,3.3601227,5.4438477,5.4143906,9.4480934,5.4143906c0.3366814,0,0.6760674-0.0147552,1.0171509-0.0442581
					c2.7649002-0.2388611,5.558712-0.5465622,8.3044662-0.914299l3.816452-0.5183563
					c4.1458054-0.5548401,7.1017838-3.5844879,7.1017838-7.2039108V57.688221
					C69.4300003,54.0690575,66.4742432,51.0394135,62.3284416,50.4840546z M31.4508934,58.3478775l-7.4251747,14.6924896
					c-0.7535954,1.3664017-2.4742832,2.1743469-4.301075,2.0182953c-2.666563-0.2305832-5.3610744-0.527153-8.0082273-0.881691
					l-3.794107-0.5183563c-1.1275439-0.1511383-1.5623093-0.7416916-1.5623093-0.9003296V57.688221
					c0-0.1586342,0.4347653-0.7494507,1.5625682-0.9005852l3.8318901-0.5180931
					c1.1507053-0.15411,2.2892475-0.2929497,3.4490757-0.4240913c0.3359079-0.0379791,0.6629524-0.0733032,0.9993467-0.1092758
					c0.8773918-0.0940704,1.7516785-0.1812172,2.6320782-0.2619591c0.3261395-0.0298882,0.6495762-0.0615273,0.9760399-0.0895386
					c1.1486664-0.098793,2.2974396-0.1884651,3.4475956-0.2644196c0.2119484-0.0139732,0.4236908-0.0238075,0.6357346-0.0370064
					c0.9574871-0.0596504,1.9142246-0.1114082,2.8703537-0.155014c0.2507992-0.0115166,0.5015144-0.0208969,0.7523766-0.0313148
					c1.178236,0.0056953,2.2811203,0.4232521,3.0553188,1.165844c0.4280376,0.4104424,0.9378147,1.1006317,0.9370384,2.0578918
					C31.5094166,58.1946716,31.4897118,58.2710152,31.4508934,58.3478775z M63.0699997,72.7582855
					c0,0.158638-0.4576683,0.7491913-1.5857315,0.9003296l-3.843338,0.5183563
					c-2.6476707,0.354538-5.3286285,0.6511078-7.9949341,0.881691c-1.8226509,0.1568222-3.5408325-0.6524048-4.2946854-2.0182953
					l-7.4221115-14.6940422c-0.0382996-0.0758286-0.0563049-0.1519127-0.0563049-0.2254066
					c-0.0007782-0.9572601,0.510128-1.6477089,0.9384232-2.0584068c0.7958717-0.7630424,1.9469948-1.1794319,3.1557007-1.1613808
					c0.2171249,0.0091209,0.4344902,0.0171432,0.6516113,0.0271072c0.9578438,0.0436058,1.9167633,0.0954933,2.8759956,0.1552734
					c0.2101059,0.013134,0.4205513,0.0229034,0.630558,0.036747c1.151226,0.0759544,2.3022804,0.1656265,3.4520798,0.2646141
					c0.3243599,0.0278168,0.6481171,0.0592613,0.972187,0.0888939c0.8829536,0.0809975,1.7646217,0.1684036,2.6445694,0.2627335
					c0.3345184,0.0358429,0.6692314,0.0709076,1.0032654,0.1086922c1.1605377,0.1312714,2.3187828,0.2701111,3.4702339,0.4243507
					l3.8167496,0.5180931c1.1280632,0.1511345,1.5857315,0.741951,1.5857315,0.9005852V72.7582855z" />
				<path fill="#5994C9" d="M41.7691574,94.106575H27.6214848c-3.1466389,0-5.6974945-2.5508575-5.6974945-5.6974945V86.490921
					c0-3.146637,2.5508556-5.6974945,5.6974945-5.6974945h14.1476727c3.146637,0,5.6974945,2.5508575,5.6974945,5.6974945v1.9181595
					C47.4666519,91.5557175,44.9157944,94.106575,41.7691574,94.106575z" />
				<path fill="#F9914B" d="M54.7442398,114.8857803c-13.977459,0-25.3489075-11.3714523-25.3489075-25.3489075
					c0-2.9271622,2.3728371-5.2999954,5.2999992-5.2999954s5.2999992,2.3728333,5.2999992,5.2999954
					c0,8.1324463,6.6162033,14.748909,14.748909,14.748909s14.7489014-6.6164627,14.7489014-14.748909V2.1199999h10.6000061
					v87.4168701C80.0931473,103.514328,68.7216949,114.8857803,54.7442398,114.8857803z" />
				<path opacity="0.4" fill="#FFFFFF" d="M36.3176727,62.4117508l6.1177292,12.1056671
					c1.3449669,2.4992905,4.2986717,3.9769821,7.3916588,3.7094345c2.7268448-0.235878,5.4468613-0.5352478,8.1563721-0.8981018
					l3.8699532-0.5182495C64.3939285,76.4702759,66.25,74.7596207,66.25,72.7583389V57.6880951
					c0-2.0012817-1.8560715-3.711937-4.3966141-4.0521584l-3.8699532-0.5182571
					c-7.7430916-1.0369377-15.5719681-1.5554085-23.4008446-1.5554123
					c-7.8288746,0.0000038-15.6577492,0.5184746-23.4008408,1.5554123l-3.8699522,0.5182571
					c-2.5405455,0.3402214-4.396615,2.0508766-4.396615,4.0521584v15.0702438c0,2.0012817,1.8560696,3.711937,4.396615,4.0521622
					l3.8699522,0.5182495c2.7095118,0.362854,5.4295282,0.6622238,8.156373,0.8981018
					c3.0929871,0.2675476,6.0466919-1.210144,7.3916569-3.7094345l6.1177311-12.1056671V62.411747
					c0.8187561-1.2504883,2.6514091-1.2504883,3.4701653,0V62.4117508z" />
				<path fill="#5994C9" d="M80.0299988,5.3000002H69.4300003c-1.4634552,0-2.6500015-1.1865482-2.6500015-2.6500001
					S67.9665451,0,69.4300003,0h10.5999985c1.4634552,0,2.6500015,1.1865479,2.6500015,2.6500001
					S81.493454,5.3000002,80.0299988,5.3000002z" />
				<path fill="#5994C9" d="M80.0299988,67.8399963H69.4300003c-1.4634552,0-2.6500015-1.1865463-2.6500015-2.6499939
					c0-1.4634552,1.1865463-2.6500015,2.6500015-2.6500015h10.5999985c1.4634552,0,2.6500015,1.1865463,2.6500015,2.6500015
					C82.6800003,66.65345,81.493454,67.8399963,80.0299988,67.8399963z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 5
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="45.7279" cy="85.75606" />
				<path fill="#5994C9" d="M82.32058,66.67705l-5.07611-0.68427c-1.57867-0.2114-3.14628-0.40144-4.73418-0.58105
					c-0.45878-0.05196-0.90907-0.09998-1.36862-0.14928c-1.2018-0.12877-2.401-0.24823-3.60669-0.3588
					c-0.44784-0.04102-0.89242-0.08426-1.34064-0.12288c-1.56876-0.13475-3.13835-0.25755-4.71142-0.36137
					c-0.30779-0.02033-0.61443-0.03461-0.92222-0.05375c-1.28849-0.07998-2.57739-0.14987-3.86733-0.20892
					c-0.24071-0.01102-0.48197-0.02879-0.72255-0.03905c-0.06084-0.00256-0.12071-0.09733-0.18151-0.09912
					C52.46635,63.87893,49.14163,63.7,45.82368,63.7h-0.0082c-3.31671,0-6.64039,0.17893-9.96218,0.31847
					c-0.06195,0.00179-0.12309,0.04631-0.18508,0.04896c-0.24084,0.01025-0.48249,0.05315-0.72346,0.06426
					c-1.28806,0.05896-2.57535,0.14133-3.862,0.22123c-0.30984,0.01923-0.61912,0.03977-0.92896,0.06028
					c-1.57188,0.10374-3.14137,0.22958-4.70898,0.36425c-0.45032,0.0388-0.89927,0.08377-1.3492,0.12513
					c-1.20338,0.11023-2.40463,0.2303-3.60412,0.35882c-0.46095,0.04939-0.92148,0.09798-1.38167,0.1501
					c-1.58743,0.17953-3.17209,0.36967-4.75025,0.58108l-5.01074,0.68438C3.87358,67.41045,0,71.41196,0,76.19199v19.90385
					c0,4.78037,3.87358,8.78179,9.34883,9.5146l5.06099,0.68462c3.62612,0.48569,7.29104,0.89209,10.94314,1.20757
					c0.45083,0.03896,0.88636,0.05844,1.33138,0.05844c5.28862,0,10.08425-2.71352,12.47272-7.15141l6.66562-13.19405l6.61737,13.098
					l0.04946,0.09639c2.38882,4.43789,7.18999,7.15107,12.47861,7.15107c0.44468,0,0.89292-0.01948,1.34341-0.05844
					c3.65176-0.31548,7.3417-0.72188,10.96816-1.20757l5.0406-0.68462c5.47559-0.73281,9.37971-4.73423,9.37971-9.5146V76.19199
					C91.7,71.41196,87.79617,67.41055,82.32058,66.67705z M41.53892,77.06323l-9.80684,19.40517
					c-0.99531,1.80469-3.26792,2.87178-5.68066,2.66567c-3.52188-0.30453-7.08066-0.69624-10.5769-1.1645l-5.01108-0.68462
					C8.97422,97.08535,8.4,96.30537,8.4,96.09585V76.19199c0-0.20953,0.57422-0.98985,2.06377-1.18945l5.06099-0.68428
					c1.5198-0.20354,3.02353-0.38691,4.55538-0.56012c0.44365-0.05016,0.8756-0.09681,1.31989-0.14433
					c1.15882-0.12424,2.31354-0.23934,3.47633-0.34598c0.43075-0.03948,0.85793-0.08127,1.28911-0.11826
					c1.51711-0.13049,3.03436-0.24892,4.55343-0.34924c0.27993-0.01846,0.55959-0.03144,0.83965-0.04887
					c1.26461-0.07878,2.52822-0.14714,3.79103-0.20473c0.33125-0.01521,0.66238-0.0276,0.99371-0.04136
					c1.55616,0.00752,3.0128,0.55901,4.03532,1.53979c0.56533,0.54209,1.23862,1.45366,1.2376,2.71797
					C41.61621,76.86089,41.59019,76.96172,41.53892,77.06323z M83.3,96.09585c0,0.20953-0.60447,0.9895-2.09436,1.18911
					l-5.07611,0.68462c-3.49693,0.46826-7.03781,0.85996-10.55935,1.1645c-2.40727,0.20713-4.67657-0.86166-5.67223-2.66567
					l-9.80279-19.40723c-0.05058-0.10014-0.07437-0.20063-0.07437-0.29771c-0.00102-1.26431,0.67376-2.17622,1.23943-2.71865
					c1.05115-1.00779,2.5715-1.55774,4.16791-1.5339c0.28677,0.01205,0.57385,0.02264,0.86062,0.0358
					c1.26508,0.05759,2.53157,0.12612,3.79848,0.20508c0.2775,0.01734,0.55544,0.03025,0.83281,0.04853
					c1.52048,0.10032,3.04074,0.21875,4.55935,0.34949c0.42841,0.03674,0.85601,0.07828,1.28402,0.11741
					c1.16617,0.10699,2.33064,0.22243,3.49284,0.34701c0.44181,0.04734,0.88389,0.09366,1.32507,0.14355
					c1.53278,0.17338,3.06255,0.35675,4.58333,0.56046l5.04099,0.68428C82.69553,75.20215,83.3,75.98247,83.3,76.19199V96.09585z" />
				<path fill="#5994C9" d="M55.16681,124.2917H36.4812c-4.15594,0-7.52499-3.36906-7.52499-7.52499v-2.53342
					c0-4.15594,3.36905-7.52499,7.52499-7.52499h18.68561c4.15594,0,7.52499,3.36906,7.52499,7.52499v2.53342
					C62.6918,120.92265,59.32275,124.2917,55.16681,124.2917z" />
				<path fill="#F9914B" d="M72.30371,151.73593c-18.46079,0-33.47969-15.01889-33.47969-33.47968c0-3.86607,3.13393-7,7-7
					s7,3.13393,7,7c0,10.74097,8.73838,19.47968,19.47969,19.47968s19.47969-8.73871,19.47969-19.47968V2.8h14v115.45625
					C105.7834,136.71704,90.7645,151.73593,72.30371,151.73593z" />
				<path opacity="0.4" fill="#FFFFFF" d="M47.96674,82.43062l8.08002,15.98861c1.77637,3.30095,5.67749,5.25262,9.76257,4.89925
					c3.60149-0.31154,7.19396-0.70692,10.77257-1.18616l5.11126-0.68449C85.04858,100.99847,87.5,98.73912,87.5,96.09592v-19.9041
					c0-2.6432-2.45142-4.90255-5.80685-5.35191l-5.11126-0.68449c-10.22673-1.36954-20.56675-2.05431-30.90678-2.05432
					c-10.34002,0.00001-20.68005,0.68478-30.90677,2.05432l-5.11126,0.68449c-3.35544,0.44936-5.80685,2.70871-5.80685,5.35191
					v19.9041c0,2.6432,2.45141,4.90256,5.80685,5.35191l5.11126,0.68449c3.5786,0.47924,7.17107,0.87463,10.77257,1.18616
					c4.08508,0.35337,7.9862-1.5983,9.76257-4.89925l8.08002-15.98861v-0.00001
					C44.46488,80.77902,46.88536,80.77902,47.96674,82.43062L47.96674,82.43062z" />
				<path fill="#5994C9" d="M105.7,7h-14c-1.93286,0-3.5-1.56714-3.5-3.5S89.76714,0,91.7,0h14c1.93286,0,3.5,1.56714,3.5,3.5
					S107.63286,7,105.7,7z" />
				<path fill="#5994C9" d="M105.7,89.6h-14c-1.93286,0-3.5-1.56714-3.5-3.5s1.56714-3.5,3.5-3.5h14c1.93286,0,3.5,1.56714,3.5,3.5
					S107.63286,89.6,105.7,89.6z" />
			</g>
		);
	}
}

function Scuba(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisScuba = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisScuba)) {
		return null;
	}

	return <ThisScuba {...props} />;
}

export default Scuba;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Scuba.js